import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { AddressService } from '../../../../core/services/address/address/address.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { NgxMaskDirective } from 'ngx-mask'

@Component({
  selector: 'address-patient-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    MatSlideToggle,
    NgxMaskDirective,
  ],
  templateUrl: './address-client-edit-form.component.html',
  styleUrl: './address-client-edit-form.component.scss',
  providers: [AddressTypeService, AddressService, ViaCepService],
  standalone: true,
})
export class AddressClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private addressTypeService: AddressTypeService,
    private addressService: AddressService,
    private viaCepService: ViaCepService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() address: any = {}
  @Input() personId: number = 0

  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.form.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
    }
  }

  checkEdit() {
    return !!this.editItem && Object.keys(this.editItem).length > 0
  }

  fillForm() {
    this.form.get('postalCode')?.setValue(this.editItem.cep)
    this.form.get('street')?.setValue(this.editItem.logradouro)
    this.form.get('number')?.setValue(this.editItem.numero)
    this.form.get('complement')?.setValue(this.editItem.complemento)
    this.form.get('neighborhood')?.setValue(this.editItem.bairro)
    this.form.get('city')?.setValue(this.editItem.cidade)
    this.form.get('country')?.setValue(this.editItem.pais)
    this.form.get('state')?.setValue(this.editItem.estado)
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.form.reset()
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('complement')?.setValue(element.complemento)
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
      this.form.get('country')?.setValue('Brasil')
    }
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      postalCode: [this.address.cep, [Validators.required]],
      street: [this.address.logradouro, [Validators.required]],
      neighborhood: [this.address.bairro, [Validators.required]],
      complement: [this.address.complemento],
      country: [this.address.pais],
      number: [this.address.numero, [Validators.required]],
      state: [this.address.estado, [Validators.required]],
      city: [this.address.cidade, [Validators.required]],
    })
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.addressService.createAddress(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.addressService.editAddress(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    if (edit) {
      return {
        id: this.address.id_endereco,
        idCreate: this.editItem.idCreate,
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
      }
    } else {
      return {
        id: this.address.id_endereco,
        cep: this.form.controls['postalCode'].value ?? '',
        logradouro: this.form.controls['street'].value ?? '',
        numero: this.form.controls['number'].value ?? '',
        complemento: this.form.controls['complement'].value ?? '',
        bairro: this.form.controls['neighborhood'].value ?? '',
        estado: this.form.controls['state'].value ?? '',
        cidade: this.form.controls['city'].value ?? '',
        pais: this.form.controls['country'].value ?? '',
      }
    }
  }
}
